import React from 'react';
import { InvoiceClientSection } from './SectionClient/InvoiceClientSection';
import { STYLES } from '../consts/consts';
import { InvoiceDatesSection } from './SectionDates/InvoiceDatesSection';
import { RemindersAndPaymentsSection } from './SectionRemindersAndPayments/RemindersAndPayments';
import { InvoiceServiceItemSection } from './SectionServiceItems/InvoiceServiceItemSection';

const { INVOICE_CREATION } = STYLES;

export const CreationFormWrapper = () => (
  <div className={INVOICE_CREATION.CREATION_FORM_WRAPPER}>
    <InvoiceClientSection />
    <InvoiceDatesSection />
    <InvoiceServiceItemSection />
    <RemindersAndPaymentsSection />
  </div>
);
